function HomeHeroSection({ heroDescription, heroTitle, portfolioStats = [] }) {
  return (
    <header className="relative isolate overflow-hidden bg-forest-950" id="top">
      <div
        className="absolute inset-0 -z-10 animate-slow-zoom bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=2400&q=80')",
        }}
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-forest-950/92 via-forest-900/80 to-forest-700/65" />
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_80%_20%,rgba(241,227,203,0.18),transparent_45%)]" />
      <div aria-hidden="true" className="pointer-events-none absolute -left-24 top-1/3 -z-10 h-72 w-72 animate-float rounded-full bg-forest-300/20 blur-3xl" />
      <div aria-hidden="true" className="pointer-events-none absolute right-[-6rem] top-16 -z-10 h-80 w-80 animate-float rounded-full bg-sand-300/20 blur-3xl [animation-delay:1.5s]" />

      <div className="site-rail flex min-h-[88vh] flex-col justify-center py-20 lg:py-28">
        <div className="max-w-[58rem]">
          <h1 className="mt-7 font-serif text-[clamp(2.8rem,7vw,6rem)] font-bold leading-[0.98] text-cream-50 text-balance">
            {heroTitle}
          </h1>
          <p className="mt-7 max-w-[60ch] text-[clamp(1.05rem,1.6vw,1.35rem)] leading-[1.7] text-cream-200/90">
            {heroDescription}
          </p>

          {portfolioStats.length > 0 ? (
            <dl className="mt-10 grid max-w-md grid-cols-2 gap-4">
              {[...portfolioStats].reverse().map((stat) => (
                <div
                  className="hover-lift rounded-3xl border border-white/15 bg-white/10 px-6 py-5 backdrop-blur-md transition hover:border-white/30 hover:bg-white/15"
                  key={stat.label}
                >
                  <dd className="m-0 font-serif text-[clamp(2.2rem,4vw,3.2rem)] font-bold leading-none text-cream-50">
                    {stat.value}
                  </dd>
                  <dt className="mt-2 text-xs font-semibold uppercase tracking-[0.18em] text-sand-200">
                    {stat.label}
                  </dt>
                </div>
              ))}
            </dl>
          ) : null}

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              className="focus-ring group inline-flex min-h-14 items-center justify-center gap-2 rounded-full bg-cream-100 px-8 text-base font-bold text-forest-900 no-underline shadow-lift transition hover:-translate-y-0.5 hover:bg-white"
              href="#eiendommer"
            >
              Se ledige eiendommer
              <span aria-hidden="true" className="transition group-hover:translate-x-1">→</span>
            </a>
            <a
              className="focus-ring inline-flex min-h-14 items-center justify-center rounded-full border border-white/30 bg-white/10 px-8 text-base font-semibold text-cream-100 no-underline backdrop-blur transition hover:bg-white/20"
              href="#kontakt"
            >
              Kontakt oss
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

export default HomeHeroSection;